<template>
  <div id="app" :style="meetingBgStyles">
    <headerComponent></headerComponent>

    <div id="routerView">
      <router-view
        :style="{ height: remainingHeightWithoutTheHeader + 'px' }"
      />
    </div>

    <modals></modals>

    <notifications></notifications>
  </div>
</template>

<script>
import headerComponent from "@/components/headerComponent.vue";
import modals from "@/components/modals.vue";
import notifications from "@/components/notifications.vue";
import { getAuth } from "firebase/auth";
import apiClient from "./apiClient";

export default {
  name: "App",

  data() {
    return {
      users: 1,
      remainingHeightWithoutTheHeader: window.innerHeight - 64,
    };
  },

  components: {
    headerComponent,
    modals,
    notifications,
  },

  created() {
    getAuth().onAuthStateChanged((user) => {
      this.$store.commit("setUserAuthenticated", user != null);
      this.$store.commit("setUser", user);

      if (user) {
        if (user.emailVerified) {
          apiClient
            .post("/user/timezone", {
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            })
            .catch((e) => console.error(e));
        }

        this.$store.dispatch("fetchSubscription");
        this.$store.dispatch("fetchReceipts");
      }
    });

    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "onShowError":
          this.onShowError();
          break;
        case "onHideError":
          this.onHideError();
          break;
      }
    });
  },

  mounted() {
    window.addEventListener("resize", this.resizeEvent);
  },

  updated() {
    this.tileHeigth();
  },

  destroyed() {
    window.removeEventListener("resize", this.resizeEvent);
  },

  methods: {
    onShowError() {
      this.$refs.errorBanner.classList.add("visible");
    },

    onHideError() {
      console.log("here");
      this.$refs.errorBanner.classList.remove("visible");
    },

    resizeEvent() {
      this.remainingHeightWithoutTheHeader = window.innerHeight - 64;
    },
  },

  watch: {
    users: function () {
      this.tileHeigth();
    },
  },

  computed: {
    usersCounter() {
      return this.$store.state.meeting.participants.length;
    },

    meetingBgStyles() {
      return {}; //TODO: Apply background here
    },
  },
};
</script>

<style>
#app {
  height: 100vh;
}

#routerView {
  position: absolute;
  top: 64px;
  left: 0;

  flex: 1;

  width: 100%;
}

#errorMessage {
  width: 100%;
  z-index: 99999;
  text-align: center;
  padding: 8px;
  font-size: 16px;
  position: fixed;
  top: -100%;
  left: 0;
  background: red;
  color: white;
  font-weight: bold;
  transition: top 600ms ease-in-out;
}

#errorMessage.visible {
  top: 0;
}
</style>
